import React from 'react';
import {CourseAccessGate} from '../../../modules/CourseAccessGate';
import CourseLearnerContainer from './container/CourseLearnerContainer';

const CourseLearner = () => {
  return (
    <CourseAccessGate>
      <CourseLearnerContainer />
    </CourseAccessGate>
  );
};

export {CourseLearner};
